/**
 * Appointment Cal.com — bootstrap once on first booking click, modal inline mounts.
 */
(function () {
  'use strict';

  var BODY_SCROLL_CLASS = 'appointment-cal-modal--scroll-lock';
  var INITED_NS = {};

  /** Resolves once app.cal.com/embed/embed.js has loaded */
  function installCalStubOnce() {
    if (window.__appointmentCalEmbedPromise) return window.__appointmentCalEmbedPromise;

    window.__appointmentCalEmbedPromise = new Promise(function (resolve, reject) {
      var C = window;
      var embedUrl = 'https://app.cal.com/embed/embed.js';
      var L = 'init';

      var p = function (a, ar) {
        a.q.push(ar);
      };
      var d = C.document;

      C.Cal =
        C.Cal ||
        function () {
          var cal = C.Cal;
          var ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            var scr = d.createElement('script');
            scr.async = true;
            scr.onload = function () {
              resolve();
            };
            scr.onerror = function () {
              reject(new Error('Cal embed failed'));
            };
            scr.src = embedUrl;
            d.head.appendChild(scr);
            cal.loaded = true;
          }
          if (ar[0] === L) {
            var api = function () {
              p(api, arguments);
            };
            var namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === 'string') {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              p(cal, ['initNamespace', namespace]);
            } else {
              p(cal, ar);
            }
            return;
          }
          p(cal, ar);
        };
    });

    return window.__appointmentCalEmbedPromise;
  }

  function fireInitNamespace(origin, ns) {
    Cal('init', ns, { origin: origin || 'https://app.cal.com' });
  }

  function ensureNamespaceMounted(origin, ns) {
    installCalStubOnce();
    /* First Cal() invokes stub and inserts embed script */
    if (!INITED_NS[ns]) {
      INITED_NS[ns] = true;
      fireInitNamespace(origin, ns);
    }
    return window.__appointmentCalEmbedPromise;
  }

  function mountIntoModal(holderEl, opts) {
    var ns = opts.namespace;
    var calLink = opts.calLink;
    holderEl.innerHTML = '';

    var mount = document.createElement('div');
    var uid = 'cal-inline-' + Math.random().toString(36).slice(2, 11);
    mount.id = uid;
    mount.style.width = '100%';
    mount.style.boxSizing = 'border-box';
    mount.style.minHeight =
      holderEl.dataset.minHeightPx != null ? holderEl.dataset.minHeightPx + 'px' : 'min(520px, 55vh)';
    mount.style.overflow = 'auto';
    holderEl.appendChild(mount);

    Cal.ns[ns]('inline', {
      elementOrSelector: '#' + uid,
      config: opts.embedConfig || {
        layout: 'month_view',
        useSlotsViewOnSmallScreen: true,
      },
      calLink: calLink,
    });
    Cal.ns[ns](
      'ui',
      opts.ui || {
        hideEventTypeDetails: false,
        layout: 'month_view',
      }
    );
  }

  async function handleOpen(btn) {
    var sectionRoot = btn.closest('[data-appointment-cal-section]');
    if (!sectionRoot) return;
    var modal = sectionRoot.querySelector('[data-appointment-modal-root]');
    var holder = sectionRoot.querySelector('[data-appointment-cal-holder]');
    var titleEl = sectionRoot.querySelector('[data-appointment-modal-title]');
    var cfgNode = sectionRoot.querySelector('[data-appointment-cal-config][type="application/json"]');
    if (!modal || !holder || !titleEl || !cfgNode) return;

    var key = btn.getAttribute('data-cal-type');
    var cfgJson = {};
    try {
      cfgJson = JSON.parse(cfgNode.textContent || '{}');
    } catch (ignore) {}

    var slot = cfgJson.slots && cfgJson.slots[key];
    if (!slot || !slot.namespace || !slot.calLink) return;

    titleEl.textContent = btn.getAttribute('data-modal-heading') || '';

    modal.hidden = false;
    modal.removeAttribute('hidden');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    holder.innerHTML =
      '<p class="appointment-booking-modal__loading">' +
      (window.appointmentCalLoadingText || 'Loading…') +
      '</p>';

    document.documentElement.classList.add(BODY_SCROLL_CLASS);

    await ensureNamespaceMounted(cfgJson.origin, slot.namespace);
    holder.innerHTML = '';
    mountIntoModal(holder, {
      origin: cfgJson.origin,
      namespace: slot.namespace,
      calLink: slot.calLink,
    });

    var closeBtn = modal.querySelector('[data-appointment-modal-close]');
    if (closeBtn) closeBtn.focus();
  }

  function handleClose(modalPassed) {
    var modalEl = modalPassed;
    if (modalPassed && modalPassed.closest) {
      modalEl = modalPassed.closest('[data-appointment-modal-root].is-open');
    }
    if (!modalEl) {
      modalEl = document.querySelector('[data-appointment-modal-root].is-open');
    }
    if (!modalEl || !modalEl.classList.contains('is-open')) return;

    modalEl.classList.remove('is-open');
    modalEl.hidden = true;
    modalEl.setAttribute('hidden', 'hidden');
    modalEl.setAttribute('aria-hidden', 'true');

    var holder = modalEl.querySelector('[data-appointment-cal-holder]');
    if (holder) holder.innerHTML = '';

    document.documentElement.classList.remove(BODY_SCROLL_CLASS);
  }

  document.addEventListener('click', function (e) {
    var bt = e.target.closest('[data-appointment-open-cal]');
    if (bt) {
      e.preventDefault();
      handleOpen(bt);
      return;
    }
    var closeBt = e.target.closest('[data-appointment-modal-close]');
    if (closeBt) {
      e.preventDefault();
      handleClose(closeBt.closest('[data-appointment-modal-root]'));
      return;
    }
    var ov = e.target.closest('[data-appointment-modal-overlay]');
    if (ov && ov.closest('[data-appointment-modal-root]')) {
      handleClose(ov.closest('[data-appointment-modal-root]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') handleClose();
  });
})();
